import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { functionThatReturnsTrue } from '@nu-art/ts-common';
import { ComponentSync } from '../../../core/ComponentSync.js';
import { TS_Icons } from '@nu-art/ts-styles';
import './Dialog_ActionProcessorConfirmation.scss';
import { ModuleFE_Dialog } from '../../../component-modules/ModuleFE_Dialog.js';
import { LL_H_C, LL_V_L } from '../../../components/Layouts/index.js';
import { Button } from '../../../components/Button/Button.js';
export class Dialog_ActionProcessorConfirmation extends ComponentSync {
    // ######################### Static #########################
    static show(action, onExecute) {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_ActionProcessorConfirmation, { action: action, onExecute: onExecute }),
            closeOverlayOnClick: functionThatReturnsTrue
        });
    }
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
    }
    // ######################### Logic #########################
    closeDialog = () => {
        ModuleFE_Dialog.close(true);
    };
    executeAction = () => {
        this.props.onExecute();
        this.closeDialog();
    };
    // ######################### Render #########################
    renderHeader = () => {
        return _jsx(LL_H_C, { className: 'dialog__header', children: _jsx("div", { className: 'dialog__header__title', children: "Refactoring Action Conformation" }) });
    };
    renderMain = () => {
        return _jsxs(LL_H_C, { className: 'dialog__main', children: [_jsx(TS_Icons.information.component, { className: 'dialog__main__warning-icon' }), _jsxs(LL_V_L, { className: 'dialog__main__warning', children: [_jsx("div", { className: 'dialog__main__warning__title', children: "Action Description" }), _jsx("div", { className: 'dialog__main__warning__text', children: this.props.action.description })] })] });
    };
    renderButtons = () => {
        return _jsxs(LL_H_C, { className: 'dialog__buttons', children: [_jsx(Button, { onClick: this.closeDialog, children: "Cancel" }), _jsx(Button, { onClick: this.executeAction, children: "Execute" })] });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'dialog-refactoring-action-conformation', children: [this.renderHeader(), this.renderMain(), this.renderButtons()] });
    }
}
//# sourceMappingURL=Dialog_ActionProcessorConfirmation.js.map